import React from "react"
import { Wave } from "react-animated-text"
import styles from "./Team.module.css"
import Techllustration from "./Techllustration"

const EventTeam = () => {
  const [width, setWidth] = React.useState()
  React.useEffect(() => {
    setWidth(window.innerWidth)
  }, [])
  const updateDimensions = () => {
    setWidth(window.innerWidth)
  }
  const updateWidth = () => {
    setWidth(window.innerWidth)
  }

  React.useEffect(() => {
    window.addEventListener("resize", updateWidth)
    return () => {
      window.removeEventListener("resize", updateDimensions)
    }
  }, [width])
  const text = `Technical Team`
  return (
    <div className={styles.container}>
      <div className={styles.subContainer}>
        <span className={styles.heading}>
          <Wave text={text} effect="stretch" iterations={1} effectChange={2} />
        </span>
        {width <= 768 && <Techllustration />}
        <span className={styles.para}>
          {" "}
          The name implies the main motive; this team plays a prominent role in
          maintaining the technical things in our CSI. This team consists of
          curious developers and peeps with a good base in Website development
          for supporting the Club's official website, implementing new features
          and maintaining the database. &nbsp;
          <a href="/team/tech_team" rel="noreferrer">
            Know More...
          </a>
        </span>
      </div>
      {width > 768 && <Techllustration />}
    </div>
  )
}

export default EventTeam
